import { User } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { currentUserStore } from "@/store/typed";
@Component
export default class AuthorizationMixin extends Vue {
  get currentUser() {
    return currentUserStore.currentUser;
  }

  get authPolicy() {
    return {
      companyFamilies: {
        update: this.canEditCompanyFamily(),
        updateMarkup: this.canEditCompanyFamilyMarkUp(),
      },
      products: {
        update: this.canEditProducts(),
      },
    };
  }

  authPolicyByAction(type: string, action: string) {
    const typePolicy = this.authPolicy[type];
    if (typePolicy) {
      return typePolicy[action] || false;
    }
    return false;
  }

  canEditCompanyFamilyMarkUp() {
    return this.currentUser.isCompanyAdministrator;
  }

  canEditProducts() {
    return User.adminRoles.map((o) => o.id).includes(this.currentUser.role);
  }

  canEditCompanyFamily() {
    return User.adminRoles.map((o) => o.id).includes(this.currentUser.role);
  }
}
